import {useProject} from "../Context/ProjectContext";
import {useEffect, useState} from "react";
import {Button, Card, notification, Select, Typography} from "antd";
import BaseLayout from "../Components/layout/layout-with-sider/BaseLayout";
import renderKey from "../Components/Output/RenderService";
import { jsPDF } from "jspdf";
import InternalSummaryPanel from "../Components/InternalSummaryPanel";
import CompareSummaryPanel from "../Components/CompareSummaryPanel";
import EmptyLine from "../Components/EmptyLine";
import {useUser} from "../Context/UserContext";
import ProjectInfo from "../Components/ProjectInfo";
import ApiService from "../Service/ApiService";
import FileHelper from "../Helpers/FileReader";

export default function ReportPage() {
    const {user} = useUser()
    const {projectHistory, selectedReportId, setSelectedReportId} = useProject()
    const [outputs, setOutputs] = useState([])

    useEffect(() => {
        if(!selectedReportId) {
            let last = projectHistory[projectHistory.length-1];
            if(last)
                setSelectedReportId(last.id)
        }
    }, [selectedReportId])

    useEffect(() => {
        if(selectedReportId) {
            const project = projectHistory.find(x => x.id === selectedReportId)
            let _outputs = []
            if(project) {
                if(project.type === 'internal') {
                    _outputs.push((
                        <div>
                            <Typography.Title level={1} style={{fontSize: '14pt', fontFamily: 'Calibri'}}>
                                Check Report
                            </Typography.Title>
                            <p>
                                {project?.project?.project?.information?.title} - {project?.project?.plan?.plan?.title}
                                <br/>
                                {project?.date?.toLocaleString()}
                            </p>
                            <br/>
                            <Typography.Title level={1} style={{fontSize: '14pt', fontFamily: 'Calibri'}}>
                                Project Information
                            </Typography.Title>
                            <ProjectInfo
                                report={true}
                                autoHeight={true}
                                folderName={project?.project?.project?.information?.folderName}
                                title={project?.project?.project?.information?.title}
                                descriptions={project?.project?.project?.information?.descriptions || []}
                                planTitle={project?.project?.plan?.plan?.title}
                                version={project?.project?.project?.projectFiles && project?.project?.project?.projectFiles.length > 0 && (
                                    project?.project?.plan?.plan?.version
                                )}
                            />
                            <br/>
                            <Typography.Title level={1} style={{fontSize: '14pt', fontFamily: 'Calibri'}}>
                                Plan Summary Statistics
                            </Typography.Title>
                            <InternalSummaryPanel report={true} summary={project.summary} />
                            <br/>
                            <br/>
                        </div>
                    ))
                }
                else if(project.type === 'comparison') {
                    _outputs.push((
                        <>
                            <Typography.Title level={1} style={{fontSize: '14pt', fontFamily: 'Calibri'}}>
                                Comparison Report
                            </Typography.Title>
                            <p>
                                {project?.base?.project?.information?.title} - {project?.base?.plan?.plan?.title} vs.
                                <br/>
                                {project?.compare?.project?.information?.title} - {project?.compare?.plan?.plan?.title}
                                <br/>
                                {project?.date?.toLocaleString()}
                            </p>
                            <br/>
                            <Typography.Title level={1} style={{fontSize: '14pt', fontFamily: 'Calibri'}}>
                                Project Information
                            </Typography.Title>
                            <Typography.Title level={2} style={{fontSize: '13pt', fontFamily: 'Calibri'}}>
                                {project?.base?.plan?.plan?.title || 'Base'}{' '}Plan
                            </Typography.Title>
                            <ProjectInfo
                                report={true}
                                autoHeight={true}
                                folderName={project?.base?.project?.information?.folderName}
                                title={project?.base?.project?.information?.title}
                                descriptions={project?.base?.project?.information?.descriptions || []}
                                planTitle={project?.base?.plan?.plan?.title}
                                version={project?.base?.project?.projectFiles && project?.base?.project?.projectFiles.length > 0 && (
                                    project?.base?.plan?.plan?.version
                                )}
                            />
                            <br/>
                            <Typography.Title level={2} style={{fontSize: '13pt', fontFamily: 'Calibri'}}>
                                {project?.compare?.plan?.plan?.title || 'Comparison'}{' '}Plan
                            </Typography.Title>
                            <ProjectInfo
                                report={true}
                                autoHeight={true}
                                folderName={project?.compare?.project?.information?.folderName}
                                title={project?.compare?.project?.information?.title}
                                descriptions={project?.compare?.project?.information?.descriptions || []}
                                planTitle={project?.compare?.plan?.plan?.title}
                                version={project?.compare?.project?.projectFiles && project?.compare?.project?.projectFiles.length > 0 && (
                                    project?.compare?.plan?.plan?.version
                                )}
                            />
                            <br/>
                            <Typography.Title level={1} style={{fontSize: '14pt', fontFamily: 'Calibri'}}>
                                Plan Summary Statistics
                            </Typography.Title>
                            <CompareSummaryPanel preparing={false} />
                            <br/>
                        </>
                    ))
                }

                project.operations.forEach(op => {
                    // if(_outputs.length > 0)
                    //     _outputs.push(<div style={{marginBottom: 24}} />)

                    let childs = op.children
                        .filter(x => x.result?.result?.length && x.result?.result?.length > 0)

                    let header = (
                        <Typography.Title level={1} style={{fontSize: '14pt', fontFamily: 'Calibri'}}>
                            {op.title}
                        </Typography.Title>
                    )

                    if(childs.length > 0)
                        _outputs.push(header)

                    childs.forEach(child => {
                        _outputs.push(
                            <>
                                {
                                    child.result.result && (
                                        renderKey.renderOutput({
                                            key: child.key,
                                            result: child.result.result,
                                            errors: child.result.errors,
                                            globalVariables: child.result.global_variables,
                                            report: true,
                                            settings: user.settings
                                        })
                                    )
                                }
                            </>
                        )
                    })
                    // _outputs.push(<div style={{marginTop: 32}} />)
                })
            }
            setOutputs(_outputs)
        }
        else {
            setOutputs([])
        }
    }, [selectedReportId])

    const onChangeResult = (id) => {
        setSelectedReportId(id)
    }

    const getTitle = (prjHistory) => {
        if(prjHistory && prjHistory.type === 'internal')
            return (
                <span>
                    Model {prjHistory?.project?.model?.trim().toUpperCase()} {prjHistory?.project?.project?.information?.title} - {prjHistory?.project?.plan?.type}
                </span>
            )
        else if(prjHistory && prjHistory.type === 'comparison')
            if(prjHistory?.base?.project?.information?.title === prjHistory?.compare?.project?.information?.title) {
                return (
                    <span>
                    Model {prjHistory?.base?.model?.trim().toUpperCase()} {prjHistory?.base?.project?.information?.title} - {prjHistory?.base?.plan?.type} vs {prjHistory?.compare?.plan?.type}
                </span>
                )
            }

            return (
                <span>
                    Model {prjHistory?.base?.model?.trim().toUpperCase()} {prjHistory?.base?.project?.information?.title} - {prjHistory?.base?.plan?.type} vs Model {prjHistory?.compare?.model?.trim().toUpperCase()} {prjHistory?.compare?.project?.information?.title} - {prjHistory?.compare?.plan?.type}
                </span>
            )
    }

    const copyTable = () => {
        const elTable = document.getElementById('report-result')

        let range, sel;

        if (document.createRange && window.getSelection) {
            elTable.style.fontFamily = "Calibri";
            range = document.createRange();
            sel = window.getSelection();
            // unselect any element in the page
            sel.removeAllRanges();

            try {
                range.selectNodeContents(elTable);
                sel.addRange(range);
            } catch (e) {
                range.selectNode(elTable);
                sel.addRange(range);
            }

            document.execCommand('copy');

            notification.success({
                message: 'Result Copied!'
            })
        }

        sel.removeAllRanges();
    }

    const dateStr = (date) => {
        return `${(date.getMonth()+1).toString().padStart(2, '0')}${date.getDate().toString().padStart(2, '0')}${date.getFullYear()}_${date.getHours().toString().padStart(2, '0')}${date.getMinutes().toString().padStart(2, '0')}`
    }

    const getFileName = () => {
        const project = projectHistory.find(x => x.id === selectedReportId)
        if(project) {
            if(project.type === 'internal') {
                return `${project?.project?.project?.information?.title?.trim()} - ${project?.project?.plan?.type} - ${dateStr(project.date)}`
            }

            if(project.type === 'comparison') {
                if(project?.base?.project?.information?.title === project?.compare?.project?.information?.title) {
                    return `${project?.base?.project?.information?.title?.trim()} - ${project?.base?.plan?.type} vs ${project?.compare?.plan?.type} - ${dateStr(project?.date)}`
                }
                else {
                    return `${project?.base?.project?.information?.title?.trim()} - ${project?.base?.plan?.type} vs ${project?.compare?.project?.information?.title} - ${project?.compare?.plan?.type} - ${dateStr(project?.date)}`
                }
            }
        }
    }

    async function downloadPDF() {

        const reportHtml = document.getElementById('report-result')
        const res = await ApiService.Report.DownloadPDF(`
        <html><head></head><body style="font-family: Calibri">${reportHtml.innerHTML}</body></html>
        `)

        if(res.success) {
            const base64data = res.data;
            var a = document.createElement("a"); //Create <a>
            a.href = 'data:application/text;base64,'+base64data; //Image Base64 Goes here
            a.download = `${getFileName()}.pdf`; //File name Here
            a.click(); //Downloaded file
        }
    }

    async function dataUrlToFile(dataUrl, fileName) {
        const res = await fetch(dataUrl);
        const blob = await res.blob();
        return new File([blob], fileName);
    }

    async function downloadWord() {
        const reportHtml = document.getElementById('report-result')
        const res = await ApiService.Report.DownloadWord(`
        <html><head></head><body style="font-family: Calibri;font-size: 11pt;">${reportHtml.innerHTML}</body></html>
        `)

        if(res.success) {
            const base64data = res.data;
            var a = document.createElement("a"); //Create <a>
            a.href = 'data:application/text;base64,'+base64data; //Image Base64 Goes here
            a.download = `${getFileName()}.docx`; //File name Here
            a.click(); //Downloaded file
        }
    }

    return (
        <>
            <BaseLayout>
                <Card title={'Report'}>
                    <b>Select Check or Comparison Results</b>
                    <Select
                        value={selectedReportId}
                        style={{width: '100%'}}
                        onChange={onChangeResult}
                    >
                        <Select.OptGroup label={'Check'}>
                            {
                                projectHistory && projectHistory.filter(x => x.type === 'internal').map(prj => (
                                    <Select.Option key={prj.id} value={prj.id}>
                                        {getTitle(prj)}
                                    </Select.Option>
                                ))
                            }
                        </Select.OptGroup>
                        <Select.OptGroup label={'Comparison'}>
                            {
                                projectHistory && projectHistory.filter(x => x.type === 'comparison').map(prj => (
                                    <Select.Option key={prj.id} value={prj.id}>
                                        {getTitle(prj)}
                                    </Select.Option>
                                ))
                            }
                        </Select.OptGroup>
                    </Select>
                    <div style={{display: 'flex', gap: 8, marginTop: 16}}>
                        <Button
                            size={'small'}
                            type={'primary'}
                            onClick={copyTable}
                        >
                            Copy to Clipboard
                        </Button>
                        <Button
                            size={'small'}
                            type={'primary'}
                            onClick={downloadPDF}
                        >
                            Download as PDF
                        </Button>
                        <Button
                            size={'small'}
                            type={'primary'}
                            onClick={downloadWord}
                        >
                            Download as Word
                        </Button>
                    </div>
                </Card>
                <br/>
                <div style={{width: '100%',}}>
                    <div style={{backgroundColor: '#fff', padding: '1.27cm', width: '23cm', height: '27.94cm', overflowY: 'auto'}}>
                        <div id={'report-result'} style={{fontFamily: 'Calibri', fontSize: '11pt'}}>
                            {outputs}
                        </div>
                    </div>
                </div>
            </BaseLayout>
        </>
    )
}